export default __webpack_public_path__ + "static/media/latest-news-img11.0f223881.jpg";